/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


// Renders Component in the anchor frame of the given border.
// Sets (0, 0) as vertical-left border centerpoint adjusted for visible border width.


const getTransform = ({ borderGeometry }) =>
{
  const distance = borderGeometry.getCenterToPartitionDistance() - borderGeometry.getWidth() / 2;

  return `rotate(${borderGeometry.getRotationDegrees()}) translate(${- distance}, 0)`;
};


const Center = ({ Component, ...props }) =>
(
  <g transform = {getTransform(props)} >
    <Component {...props} />
  </g>
);


export default ({ index, ...props }) =>
{
  const borderGeometry = props.zoneGeometry.getBorders()[index];

  return <Center {...props} borderGeometry = {borderGeometry} />;
};
